import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CategoriesRoutingModule } from './categories-routing.module';
import { CategoryListComponent } from './category-list/category-list.component';
import {ListViewModule, VirtualizationService} from '@syncfusion/ej2-angular-lists';
import {ControlsModule} from '../controls/controls.module';
import { ToastModule } from '@syncfusion/ej2-angular-notifications';
import {FormsModule} from '@angular/forms';
import {SwitchModule} from '@syncfusion/ej2-angular-buttons';

@NgModule({
  declarations: [CategoryListComponent],
  imports: [
    CommonModule,
    CategoriesRoutingModule,
    ListViewModule,
    ControlsModule,
    ToastModule,
    FormsModule,
    SwitchModule
  ],
  providers: [
    VirtualizationService
  ]
})
export class CategoriesModule { }
